export default class Labels {
}
Labels.LABELS = [
	{
		"value_fr": "",
		"value_en": "",
		"value_it": "Clicca sui diversi hotspots per accedere alle aree indicate sulla mappa.",
		"value_de": "",
		"value_es": "",
		"id": "mapLegenda"
	},
	{
		"value_fr": "",
		"value_en": "",
		"value_it": "Ruota per favore il tuo dispositivo.",
		"value_de": "",
		"value_es": "",
		"id": "turnPhone"
	},
	{
		"value_fr": "",
		"value_en": "",
		"value_it": "Continua",
		"value_de": "",
		"value_es": "",
		"id": "continua"
	},
	{
		"value_fr": "",
		"value_en": "",
		"value_it": "Muoviti a 360°",
		"value_de": "",
		"value_es": "",
		"id": "instr0"
	},
	{
		"value_fr": "",
		"value_en": "",
		"value_it": "Hotspot di navigazione",
		"value_de": "",
		"value_es": "",
		"id": "instr1"
	},
	{
		"value_fr": "",
		"value_en": "",
		"value_it": "Zoomma e naviga",
		"value_de": "",
		"value_es": "",
		"id": "instr2"
	},
	{
		"value_fr": "",
		"value_en": "",
		"value_it": "Mappa interattiva",
		"value_de": "",
		"value_es": "",
		"id": "instr3"
	},
	{
		"value_fr": "",
		"value_en": "",
		"value_it": "Freccia per muoversi <br>tra i piani",
		"value_de": "",
		"value_es": "",
		"id": "instr4"
	},
	{
		"value_fr": "",
		"value_en": "",
		"value_it": "Ruota vista",
		"value_de": "",
		"value_es": "",
		"id": "instr5"
	},
	{
		"value_fr": "",
		"value_en": "",
		"value_it": "Seleziona / Naviga",
		"value_de": "",
		"value_es": "",
		"id": "instr6"
	},
	{
		"value_fr": "",
		"value_en": "",
		"value_it": "Modifica zoom",
		"value_de": "",
		"value_es": "",
		"id": "instr7"
	},
	{
		"value_fr": "",
		"value_en": "",
		"value_it": "Italiano",
		"value_de": "",
		"value_es": "",
		"id": "lng_it"
	},
	{
		"value_fr": "",
		"value_en": "",
		"value_it": "English",
		"value_de": "",
		"value_es": "",
		"id": "lng_en"
	}
]
